import { render, staticRenderFns } from "./ContactAddresses.vue?vue&type=template&id=132d4dbd&"
import script from "./ContactAddresses.vue?vue&type=script&lang=ts&"
export * from "./ContactAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports